import * as React from "react";
import { forwardRef } from "react";
const SvgIconSchool = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 22, height: 18, viewBox: "0 0 22 18", ref, ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#036FE2", fillRule: "evenodd", d: "M11 0 0 6l4 2.18v6L11 18l7-3.82v-6l2-1.09V14h2V6L11 0Zm6.82 6L11 9.72 4.18 6 11 2.28 17.82 6ZM16 12.99l-5 2.73-5-2.73V9.27L11 12l5-2.73v3.72Z" }));
const ForwardRef = forwardRef(SvgIconSchool);
export default ForwardRef;
